import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'gatsby';
import cx from 'classnames';

import './styles.sass';

const Breadcrumbs = ({ homepageUrl, items }) => {
  const allItems = [
    { name: 'Small Business Resources', urlPath: homepageUrl },
    ...items,
  ];

  return (
    <nav className="block block__breadcrumbs">
      <ul className="breadcrumbs__list">
        {allItems.map(({ capitalize = false, name, urlPath }) => {
          return (
            <li className="breadcrumbs__list-item" key={urlPath}>
              <Link
                className={`breadcrumbs__link text-link ${cx({ capitalize })}`}
                to={urlPath}
              >
                {name}
              </Link>
            </li>
          );
        })}
      </ul>
    </nav>
  );
};

Breadcrumbs.propTypes = {
  homepageUrl: PropTypes.string.isRequired,
  items: PropTypes.arrayOf(
    PropTypes.shape({
      capitalize: PropTypes.bool,
      name: PropTypes.string,
      urlPath: PropTypes.string,
    })
  ),
};

Breadcrumbs.defaultProps = {
  items: [],
};

export default Breadcrumbs;
